
import React, { useState,useRef } from 'react';
import logo from '../../assets/image/logo.png';
import useErrorHandle from '../../hooks/ErrorHandling';
import SuccessMsg from "../../components/common/messages/SuccessMessage";
import { useNavigate } from 'react-router-dom';

import { verifiedToken } from '../../utils/CreateApi';
import { setData } from '../../utils/CookieUtiles';
import ButtonWithProgress from '../../components/reusable/Buttons/ButtonWithProgress';
import { authAccount } from '../../services/authServices';
import checkNetworkStatus from '../../components/common/networkStatus/CheckNetworkStatus';
import WarningErrorHandling from '../../hooks/WarningErrorHandling';
import useShowAlert from '../../utils/AlertUtiles';

function Login({ setLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const handleError = useErrorHandle();
  const loginPasswordRef = useRef(null);
  const loginUsernamedRef = useRef(null);
  const navigate = useNavigate();
  const showAlert = useShowAlert();
  const validateFields = () => {
    let valid = true;
    setEmailError('');
    setPasswordError('');
  
    if (!email) {
      setEmailError('This field must not be empty. Please enter the value.');
      valid = false; 
      loginUsernamedRef.current.focus();
    } else  if (!password){
     
        setPasswordError('This field must not be empty. Please enter the value.');
        valid = false; 
        loginPasswordRef.current.focus();
      }
      return valid; 
    }
  
    const handleLogin = async (e) => {
    e.preventDefault();  
    if (!validateFields()) {
      return; 
    }
    setLoading(true);
    checkNetworkStatus();
    
    try {
      const payload = {
        email,
        password,
      };

           const response = await authAccount(payload, handleError);

      if (response) {
        setData("AccessToken",response.accessToken);
        setData("RefreshToken", response.refreshToken);


        showAlert("success", SuccessMsg.LOGIN_SUCCESS_MSG);
        setLoggedIn(true); 
        verifiedToken(navigate);
      }
    } catch (error) {
      const statusCode = error.response?.data?.statusCode;
      const errorCode = error.response?.data?.code;
      console.log("er",error)
      console.log("statusCode",statusCode)
          console.log("errorCode",errorCode)
      if (statusCode === 401 ||statusCode === 422 ||  statusCode === 404 || errorCode === "PASSWORD_VERIFY_FAILURE") {
        setErrorMessage('Invalid username or password');
      } else {
        WarningErrorHandling(error, showAlert);
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
   
      <div className="wrapper">
        <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
          <div className="container">
            <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
              <div className="col mx-auto">
                <div className="card mb-0">
                  <div className="card-body">
                    <div className="p-4">
                      <div className="mb-3 text-center">
                        <img src={logo} width="100" alt="" />
                      </div>
                      <div className="text-center mb-4">
                        <h5 className="" >Admin Portal</h5>
                        {/* <h5 className="" style={{fontSize:'17px'}}>Admin Portal</h5> */}
                        <p className="mb-0">Login to your account</p>
                      </div>
                      <div className="form-body">
                        <form className="row g-3" id="ownerLoginForm" onSubmit={handleLogin}>
                          <div className="col-12">
                            <label htmlFor="username" className="form-label">
                              Username <span className="text-danger">*</span>
                            </label>
                            
                            <input
                              type="text"
                              className="form-control LogInTindex"
                              id="username"
                              onChange={(e) => setEmail(e.target.value.replace(/\s+/g, ''))}
                              autoComplete="off"
                              ref={loginUsernamedRef}
                            />   {emailError && <div className="error-message invalid-feedback" >{emailError}</div>}
                          </div>
                          {/* <span class="error-message invalid-feedback"></span> */}
                          <div className="col-12">
                            <label htmlFor="password" className="form-label">
                              Password <span className="text-danger">*</span>
                            </label>
                            <input
                              type="password"
                              className="form-control LogInTindex"
                              id="password"
                              maxLength={8}
                              autoComplete="off"
                              ref={loginPasswordRef}
                              onChange={(e) => setPassword(e.target.value)}
                            />     {passwordError && <div className="error-message invalid-feedback">{passwordError}</div>}
                          </div>
                          
                          {loading ? (<div className="col-12 py-2">
                            <div className="d-grid">
                            <ButtonWithProgress
                                buttonClass="btn btn-primary pull-right"
         
              />
                            </div>
                          </div>  ):( <div className="col-12 py-2">
                            <div className="d-grid">
                              <button
                                type="submit"  
                                className="btn btn-primary"
                                style={{ border: 'none', outline: 'none' }}
                              >
                                Login
                              </button>
                            </div>
                          </div>)}

                          {errorMessage && <div className="error-message invalid-feedback text-center">{errorMessage}</div>}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
